import { extractPublicId, buildImageUrl } from 'cloudinary-build-url'

interface RaceDetailHeroProps {
    title: string
    mainImage: string
    video?: {
        videoUrl: string
        videoThumbUrl: string
    }
    distanceText: string
    minPrice: number
    buttonText: string
    rating?: number
    isLiked?: boolean
    infoText?: string
    onButtonPress: () => void
    onSharePress?: () => void
    onPlayPress?: () => void
    isAlreadyJoined?: boolean
    isMember: boolean
}

const getCloudinaryURL = (url): string => {
    const pubID = extractPublicId(url)
    const cloudinaryUrl: string = buildImageUrl(pubID, {
        cloud: {
            cloudName: 'yes-fit'
        },
        transformations: {
            quality: 'auto',
            format: 'jpg'
        }
    })

    return cloudinaryUrl
}

export const RaceDetailHero = ({
    title = '',
    mainImage = '',
    distanceText = '',
    minPrice = 0,
    buttonText = '',
    // rating = null,
    // isLiked = null,
    infoText = '',
    onButtonPress = () => null,
    // onSharePress = () => null,
    isAlreadyJoined = false
}: RaceDetailHeroProps) => {
    return (
        <>
            <div className="grid gap-x-16 grid-cols-1 xl:grid-cols-2 bg-white">
                <div className="aspect-w-16 aspect-h-9">
                    <img
                        src={
                            mainImage.startsWith('https://res.cloudinary.com')
                                ? getCloudinaryURL(mainImage)
                                : mainImage
                        }
                    />
                </div>
                <div className="xl:flex xl:flex-col xl:justify-center pt-4 pb-0 md:pb-8 px-5 xl:p-0 rounded-tl-3xl rounded-tr-3xl">
                    <p className="uppercase text-base font-normal xl:text-xl text-yf-green">
                        virtual race | {distanceText}
                    </p>
                    <h1 className="font-medium text-3xl mb-1">{title}</h1>
                    <div className="flex flex-col mb-1">
                        <p className="text-lg md:text-2xl font-medium text-yf-green">
                            <span className="text-lg md:text-2xl text-gray-500">
                                Non-Members:{' '}
                            </span>{' '}
                            ${minPrice}+
                        </p>
                        <p className="text-lg md:text-2xl font-medium text-yf-green">
                            <span className="text-lg md:text-2xl text-gray-500">
                                VIP-Members:{' '}
                            </span>{' '}
                            $0+
                        </p>
                    </div>
                    <div className="flex max-w-[600px] mt-2">
                        {isAlreadyJoined ? (
                            <>
                                <button className="pointer-events-none py-3 bg-gray-700 text-white font-medium w-2/3 rounded-lg text-lg focus:outline-none">
                                    Joined
                                </button>
                                {/* <button
                                className="py-4 bg-transparent text-yf-purple hover:text-yf-purple-800 font-medium w-1/2 rounded-lg text-lg focus:outline-none"
                                onClick={() => onSharePress()}
                            >
                                <i className="fas fa-share mr-2"></i>
                                Share Race
                            </button> */}
                            </>
                        ) : (
                            <>
                                <button
                                    className="py-3 bg-yf-green text-white font-medium w-2/3 rounded-lg text-lg focus:outline-none focus:ring-yf-green-400 focus:ring-2 hover:bg-yf-green-600"
                                    onClick={() => onButtonPress()}
                                >
                                    {buttonText}
                                </button>
                                {/* <button
                                className="py-4 bg-transparent text-yf-purple hover:text-yf-purple-800 font-medium w-1/2 rounded-lg text-lg focus:outline-none"
                                onClick={() => onSharePress()}
                            >
                                <i className="fas fa-share mr-2"></i>
                                Share Race
                            </button> */}
                            </>
                        )}
                    </div>
                </div>
                <p>{infoText}</p>
            </div>
        </>
    )
}
